import { useState } from 'react';

interface Conversation {
  id: string;
  client: string;
  company: string;
  initials: string;
  color: string;
  lastMsg: string;
  time: string;
  unread: number;
}

interface Message {
  id: number;
  from: 'admin' | 'client';
  text: string;
  time: string;
}

const conversations: Conversation[] = [
  { id: 'c1', client: 'Petra Kovárová',   company: 'Petra K. – Kozmetika', initials: 'PK', color: 'bg-pink-600',     lastMsg: 'Kedy bude hotový nový report?',          time: 'pred 5 min',  unread: 2 },
  { id: 'c2', client: 'Lukáš Tóth',       company: 'TechFlow s.r.o.',      initials: 'TF', color: 'bg-sky-600',      lastMsg: 'Super, môžeme spustiť kampaň.',           time: 'pred 1 hod',  unread: 1 },
  { id: 'c3', client: 'Marek Sloboda',    company: 'Bratislava Pet Shop',   initials: 'BS', color: 'bg-emerald-600',  lastMsg: 'Texty som odoslal, prosím skontroluj',   time: 'pred 3 hod',  unread: 0 },
  { id: 'c4', client: 'Nina Vargová',     company: 'VitaBenefit s.r.o.',    initials: 'VB', color: 'bg-violet-600',   lastMsg: 'Nový obrázok produktu v prílohe.',       time: 'pred 1 dňom', unread: 1 },
  { id: 'c5', client: 'Róbert Mináč',     company: 'MotoLux SK',            initials: 'ML', color: 'bg-orange-600',   lastMsg: 'Ďakujem za report, vyzerá skvele!',     time: 'pred 2 dňami', unread: 0 },
];

const mockMessages: Record<string, Message[]> = {
  c1: [
    { id: 1, from: 'client', text: 'Dobrý deň, chcela by som sa opýtať na stav kampane.',                   time: '9:12' },
    { id: 2, from: 'admin',  text: 'Dobrý deň Petra! Kampaň beží dobre, CTR je 4,2 % čo je nadpriemer.',   time: '9:18' },
    { id: 3, from: 'client', text: 'Super! A kedy bude hotový nový report?',                                 time: '9:20' },
  ],
  c2: [
    { id: 1, from: 'admin',  text: 'Lukáš, kreatívy sú schválené a pripravené na spustenie.',               time: '10:05' },
    { id: 2, from: 'client', text: 'Super, môžeme spustiť kampaň.',                                         time: '10:47' },
  ],
  c3: [
    { id: 1, from: 'client', text: 'Texty som odoslal cez portál, prosím skontroluj.',                      time: 'včera 16:03' },
    { id: 2, from: 'admin',  text: 'Ďakujem, pozriem sa na to dnes poobede.',                               time: 'včera 16:10' },
  ],
  c4: [
    { id: 1, from: 'client', text: 'Posielam nový obrázok produktu v prílohe.',                             time: 'včera 9:55' },
    { id: 2, from: 'admin',  text: 'Ďakujem Nina, spracujeme ho do novej sekcie webu.',                     time: 'včera 10:30' },
  ],
  c5: [
    { id: 1, from: 'admin',  text: 'Posielame mesačný report za február, nájdete ho v portáli.',            time: '28.2. 17:00' },
    { id: 2, from: 'client', text: 'Ďakujem za report, vyzerá skvele!',                                     time: '28.2. 18:45' },
  ],
};

export default function AdminSpravy() {
  const [activeId, setActiveId] = useState('c1');
  const [input, setInput] = useState('');
  const [msgMap, setMsgMap] = useState(mockMessages);

  const activeConv = conversations.find((c) => c.id === activeId)!;
  const messages = msgMap[activeId] ?? [];

  const send = () => {
    const t = input.trim();
    if (!t) return;
    setMsgMap((prev) => ({
      ...prev,
      [activeId]: [
        ...(prev[activeId] ?? []),
        { id: Date.now(), from: 'admin', text: t, time: 'Teraz' },
      ],
    }));
    setInput('');
  };

  return (
    <div className="h-full flex overflow-hidden">
      {/* Conversation list */}
      <div className="w-64 flex-shrink-0 border-r border-zinc-800 flex flex-col">
        <div className="p-3 border-b border-zinc-800">
          <div className="flex items-center gap-2 bg-zinc-800/60 border border-zinc-700/50 rounded-xl px-3 py-2">
            <i className="ri-search-line text-zinc-500 text-sm" />
            <input placeholder="Hľadať..." className="bg-transparent text-zinc-300 text-xs placeholder:text-zinc-600 outline-none flex-1" />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto divide-y divide-zinc-800/50">
          {conversations.map((c) => (
            <button
              key={c.id}
              onClick={() => setActiveId(c.id)}
              className={`w-full flex items-start gap-3 px-4 py-3 text-left cursor-pointer transition-all ${activeId === c.id ? 'bg-zinc-800' : 'hover:bg-zinc-800/40'}`}
            >
              <div className={`w-9 h-9 rounded-xl ${c.color} flex items-center justify-center flex-shrink-0`}>
                <span className="text-white text-xs font-bold">{c.initials}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className="text-zinc-200 text-xs font-semibold truncate">{c.client}</p>
                  <span className="text-zinc-600 text-[10px] flex-shrink-0 ml-1">{c.time}</span>
                </div>
                <p className="text-zinc-600 text-[11px] truncate mt-0.5">{c.lastMsg}</p>
              </div>
              {c.unread > 0 && (
                <span className="w-4 h-4 bg-orange-500 rounded-full text-white text-[9px] font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                  {c.unread}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Chat area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Chat header */}
        <div className="flex items-center gap-3 px-5 py-3.5 border-b border-zinc-800 flex-shrink-0">
          <div className={`w-9 h-9 rounded-xl ${activeConv.color} flex items-center justify-center flex-shrink-0`}>
            <span className="text-white text-sm font-bold">{activeConv.initials}</span>
          </div>
          <div>
            <p className="text-white text-sm font-semibold">{activeConv.client}</p>
            <p className="text-zinc-500 text-xs">{activeConv.company}</p>
          </div>
          <div className="flex-1" />
          <button className="w-8 h-8 flex items-center justify-center rounded-xl hover:bg-zinc-800 transition-all cursor-pointer">
            <i className="ri-phone-line text-zinc-500" />
          </button>
          <button className="w-8 h-8 flex items-center justify-center rounded-xl hover:bg-zinc-800 transition-all cursor-pointer">
            <i className="ri-more-2-line text-zinc-500" />
          </button>
        </div>

        {/* Messages */}
        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {messages.map((m) => (
            <div key={m.id} className={`flex ${m.from === 'admin' ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[70%] rounded-2xl px-4 py-2.5 ${
                m.from === 'admin'
                  ? 'bg-orange-500 text-white rounded-tr-sm'
                  : 'bg-zinc-800 text-zinc-200 rounded-tl-sm'
              }`}>
                <p className="text-sm leading-relaxed">{m.text}</p>
                <p className={`text-[10px] mt-1 ${m.from === 'admin' ? 'text-orange-200' : 'text-zinc-600'}`}>{m.time}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Input */}
        <div className="p-4 border-t border-zinc-800 flex-shrink-0">
          <div className="flex items-center gap-3 bg-zinc-800 border border-zinc-700 rounded-2xl px-4 py-2.5">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && send()}
              placeholder="Napísať správu..."
              className="flex-1 bg-transparent text-zinc-200 text-sm placeholder:text-zinc-600 outline-none"
            />
            <div className="flex items-center gap-1 flex-shrink-0">
              <button className="w-8 h-8 flex items-center justify-center rounded-xl hover:bg-zinc-700 transition-all cursor-pointer">
                <i className="ri-attachment-line text-zinc-500 text-sm" />
              </button>
              <button
                onClick={send}
                className="w-8 h-8 flex items-center justify-center rounded-xl bg-orange-500 hover:bg-orange-600 transition-all cursor-pointer"
              >
                <i className="ri-send-plane-fill text-white text-sm" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
